import type { AdminPagination } from '../api/adminTypes'
import { Button } from '../components/ui/Button'

// Shared prev/next pager for the Accounts and Applications lists. Page-number
// buttons aren't worth building yet (admin-console.md explicitly defers
// "saved filters / configurable dashboards" to a later phase, and dev data
// today is a few dozen rows) — prev/next plus a "showing X–Y of Z" line
// covers real usage without inventing UI for data that doesn't exist yet.
export function Pager({
  pagination,
  onOffsetChange,
}: {
  pagination: AdminPagination
  onOffsetChange: (offset: number) => void
}) {
  const { offset, limit, total_count: total } = pagination
  if (total <= limit && offset === 0) return null

  const from = total === 0 ? 0 : offset + 1
  const to = Math.min(offset + limit, total)
  const canPrev = offset > 0
  const canNext = offset + limit < total

  return (
    <div
      className="flex items-center justify-between"
      style={{ marginTop: 'var(--spacing-4)', fontFamily: 'var(--font-body)' }}
    >
      <span style={{ fontSize: 'var(--text-body-sm)', color: 'var(--color-text-secondary)' }}>
        Showing {from}–{to} of {total}
      </span>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={!canPrev}
          onClick={() => onOffsetChange(Math.max(0, offset - limit))}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={!canNext}
          onClick={() => onOffsetChange(offset + limit)}
        >
          Next
        </Button>
      </div>
    </div>
  )
}
